// URL query-param overrides used by the dashboard menu-link customizer
// iframe preview and the marketing website live-demo. None of these
// override values are persisted — they only affect the current page
// view so a designer can iterate before saving.

export interface PreviewParams {
  skin: string | null;
  themeColor: string | null;
  logoUrl: string | null;
  carouselImageUrls: string[] | null;
  isPreview: boolean;
}

const EMPTY: PreviewParams = {
  skin: null,
  themeColor: null,
  logoUrl: null,
  carouselImageUrls: null,
  isPreview: false,
};

export function readPreviewParams(): PreviewParams {
  if (typeof window === "undefined") return EMPTY;
  const params = new URLSearchParams(window.location.search);
  const skin = params.get("skin");
  const themeColor = params.get("themeColor");
  const logoUrl = params.get("logoUrl");
  const carouselRaw = params.get("carouselImageUrls");
  const mode = params.get("mode");
  return {
    skin: skin || null,
    themeColor: themeColor || null,
    logoUrl: logoUrl || null,
    carouselImageUrls: carouselRaw
      ? carouselRaw.split(",").map((s) => s.trim()).filter(Boolean)
      : null,
    isPreview: mode === "preview",
  };
}
